import type { ValidationError } from './types'
import type { TOMs } from '@/types/studyTypes'

export function validateTOMs(d: TOMs): ValidationError[] {
  const errors: ValidationError[] = []

  if (!d.massnahmenBeiDerAuswertung?.length)
    errors.push({
      field: 'massnahmenBeiDerAuswertung',
      message: 'Bitte Maßnahmen bei der Verarbeitung der Daten eingeben',
    })

  if (!d.raeumlicheMassnahmen?.length)
    errors.push({ field: 'raeumlicheMassnahmen', message: 'Bitte Räumliche Massnahmen während der Verarbeitung eingeben' })

  return errors
}
